import React, {useEffect, useState} from "react";
import {Box, Container, Typography} from "@mui/material";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {toast} from "react-toastify";
import {createQueryParameterString, getQueryParameter} from "../../../../libraries/util/QueryParameterHelper";
import {LoaderForm} from "../loader-form/LoaderForm";
import {useNavigate} from "react-router-dom";
import {LoadingButton} from "@mui/lab";
import {GET_JOB_RUN} from "../graphql/queries/gqlGetJobRun";
import {NEW_RUN_FROM_EXISTING} from "../graphql/mutations/gqlNewRunFromExisting";
import {GraphQlEditor} from "../graphql-editor/GraphQlEditor";

interface INewRunFromExistingInput {
	graphQlQuery: string;
}

export const NewRunFromExistingForm = () => {
	const jobRunId: number = +(
		getQueryParameter("jobRunId") ?? "0"
	);
	let newJobRunId = 0;
	const navigate = useNavigate();
	
	const [data, setData] = useState<INewRunFromExistingInput>({
		graphQlQuery: ""
	});
	
	const [loading, setLoading] = useState(true);
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	
	// const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
	// 	setData({
	// 		...data,
	// 		[event.target.name]: event.target.value,
	// 	});
	// };
	
	const post = async () => {
		await graphQLServices.querytoolClient.mutate({
			mutation: NEW_RUN_FROM_EXISTING,
			variables: {jobRunId: jobRunId, graphQlQuery: data.graphQlQuery}
		}).then((result) => {
			console.log(result);
			newJobRunId = result.data.newRunFromExisting.jobRun.id;
			console.log(newJobRunId);
		});
	};
	
	const handleSubmit = (event: React.FormEvent) => {
		event.preventDefault();
		setLoadingSubmit(true);
		post()
			.then(() => {
				toast.success("Success");
				navigate(`/querytool/jobs/runs/steps${createQueryParameterString({
					jobRunId: newJobRunId
				})}`);
			})
			.catch(() => toast.error("Failed 1"))
			.finally(() => setLoadingSubmit(false));
	};
	
	useEffect(() => {
		if (jobRunId) {
			graphQLServices.querytoolClient.query({
				query: GET_JOB_RUN,
				variables: {
					"jobRunId": jobRunId,
				},
			})
				.then((result) => {
					setData({...data, ...result.data.jobRun.nodes[0], __typename: undefined});
				})
				.finally(() => setLoading(false));
		} else {
			setLoading(false);
		}
		// eslint-disable-next-line
	}, []);
	
	if (loading) {
		return (<LoaderForm title={"Post a Job"}/>);
	}
	
	return (
		<Container>
			<Box sx={{padding: 3}}>
				<Typography variant="h4" component="h1" align="center" gutterBottom>
					New Run From Existing Run
				</Typography>
				<form onSubmit={handleSubmit}>
					<GraphQlEditor
						query={data.graphQlQuery}
						setQuery={query => setData({...data, graphQlQuery: query})}
					/>
					
					<Box sx={{marginTop: 2}}>
						<LoadingButton loading={loadingSubmit} type="submit"  variant="contained">
							Start Run
						</LoadingButton>
					</Box>
				</form>
			</Box>
		</Container>
	);
};
